export default {
	countries: [{ code: 'US', label: 'United States of America' }],
	services: {
		sms: ['twilio', 'nexmo'],
		calendar: ['interview-scheduling'],
		autosmb:['nexmo-self-setup']
	},
	affirmatives: ['y', 'yes', 'yup', 'yeah'],
	maxMessageLength: 640,
	inviteMessage: 'Would you like to schedule a time to talk about a position?',
	noSlotsAvailableMessage: 'Recruiter is booked for the next fifteen (15) days.',
	postEventConfirmationResponseMessage: 'OK. Thank you.',
	cancelledMessage: 'Your interview on {{schedTime}} has been cancelled.',
	cancelledMessageAppend: 'Reply "1" to see new available times, or "2" if you\'re done.',
	eventReminderAppend: 'Reply "1" to confirm, "2" to reschedule, or "3" to cancel.',
	interviewInviteAppend: `\n\nReply Y and I'll send you available times.`,
	tfa: {
		cancellation: {
			cancelSuccess: 'Verification cancelled successfully.',
			noEarlyCancel: 'Request cannot be cancelled within 30 seconds.',
			expiredRequest: 'The verification code entered is invalid or expired.',
			cancelFailed: 'Error in canceling verification code.'
		},
		request: {
			requestFailed: 'Error in requesting verification code.'
		},
		check: {
			checkSuccess: 'Mobile number linked successfully.',
			checkFailed: 'Error in checking verification code.',
			notMatch: 'The verification code entered is invalid or expired.'
		},
		resend: {
			resendFailed: 'Error in resending verification code.',
		}
	}
};
